<div class="toast-host" aria-live="polite" aria-atomic="false">
  @for (n of notifications(); track n.id) {
    <div class="toast" [class]="'toast--' + n.type" role="status">
      <span class="toast__icon">
        <lucide-icon [img]="iconFor(n.type)" size="20"></lucide-icon>
      </span>

      <div class="toast__body">
        <p class="toast__title">{{ n.title }}</p>
        <p class="toast__message">{{ n.message }}</p>
      </div>

      <button type="button" class="toast__close" aria-label="Cerrar notificación" (click)="dismiss(n.id)">
        <lucide-icon [img]="closeIcon" size="16"></lucide-icon>
      </button>

      @if (n.duration > 0) {
        <span class="toast__progress" [style.animation-duration.ms]="n.duration" aria-hidden="true"></span>
      }
    </div>
  }
</div>
